import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import { useAuth } from "../Context/AuthenticateProvider";
import Logo from "../Assets/images/logo-qads.png";
import ProductBulkImportModal from "../Components/Products/Import";
import BulkStockUpload from "../Components/Stock/Import";

const Sidebar = () => {
    const { logOut } = useAuth();
    const location = useLocation();

    /* BULK IMPORT MODAL */
    const [bulkOpen, setBulkOpen] = useState(false);
    const [stockopen, setStockOpen] = useState(false)

    return (
        <>
            <aside className="app-sidebar">
                <div className="sidebar-top">
                    <div className="sidebar-logo">
                        <img src={Logo} alt="logo" />
                    </div>
                </div>

                <div className="sidebar-scroll">

                    <div className="sidebar-section">Main</div>
                    <div className="inventory-menus">
                        <NavLink to="/" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-user"></i> Dashboard
                        </NavLink>
                    </div>

                    <div className="sidebar-divider"></div>

                    <div className="sidebar-section">Customers</div>
                    <div className="inventory-menus">
                        <NavLink to="/customers" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-user"></i> Customers
                        </NavLink>
                    </div>

                    <div className="sidebar-section">Products</div>
                    <div className="inventory-menus">
                        <NavLink to="/products" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-box"></i> Products
                        </NavLink>

                        <NavLink to="/products-add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-plus-circle"></i> Create Product
                        </NavLink>

                        <div className="menu-item gap-2" style={{ cursor: "pointer" }} onClick={() => setBulkOpen(true)} >
                            <i className="bx bx-upload"></i> Bulk Import
                        </div>
                    </div>

                    <div className="sidebar-section">Quotation</div>
                    <div className="inventory-menus">
                        <NavLink to="/quotation" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx  bxs-quote-alt-left"></i> Quotations
                        </NavLink>
                        <NavLink to="/quotation-create" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-chat"></i> Create
                        </NavLink>

                    </div>

                    <div className="sidebar-section">Categories</div>
                    <div className="inventory-menus">
                        <NavLink to="/category" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-category"></i> Category
                        </NavLink>
                        <NavLink to="/subcategory" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-list-ul"></i> Sub Category
                        </NavLink>
                    </div>


                    <div className="sidebar-section">Sale POS</div>
                    <div className="inventory-menus">
                        <NavLink to="/pos" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-category"></i> POS
                        </NavLink>
                        <NavLink to="/pos-list" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-list-ul"></i> Sale List
                        </NavLink>
                        <NavLink to="/return-list" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-list-ul"></i> Return List
                        </NavLink>
                        <NavLink to="/payments" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-rupee"></i> Received Payments
                        </NavLink>
                    </div>

                    <div className="sidebar-section">Inventory Managements</div>
                    <div className="inventory-menus">
                        <NavLink to="/inventory-add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-category"></i> Add Counts
                        </NavLink>
                        <NavLink to="/history" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-category"></i> History
                        </NavLink>
                        {/* 🔥 BULK IMPORT – MODAL TRIGGER */}
                        <div className="menu-item gap-2" style={{ cursor: "pointer" }} onClick={() => setStockOpen(true)} >
                            <i className="bx bx-upload"></i> Bulk Import Stock
                        </div>
                    </div>

                    <div className="sidebar-section">Low Stocks</div>
                    <div className="inventory-menus">
                        <NavLink to="/lowstock" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-category"></i> Low Stock Alerts
                        </NavLink>
                    </div>
                    <div className="sidebar-section">Reports</div>
                    <div className="inventory-menus">
                        <NavLink to="/customer-report" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className='bx  bx-user'></i>  Customer Summary
                        </NavLink>
                        <NavLink to="/inventory-report" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className='bx  bx-package'></i>  Inventory Summary
                        </NavLink>
                        <NavLink to="/profitloss-report" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className='bx  bx-signal-4'></i>     Profit & Loss Summary
                        </NavLink>
                        <NavLink to="/sales-report" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className='bx  bx-receipt'></i>  Sales Summary
                        </NavLink>
                        <NavLink to="/top-products-report" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className='bx  bx-share'></i>  Top Products
                        </NavLink>
                    </div>
                </div>

                <div className="sidebar-footer">
                    <div className="sidebar-logo">
                        <Button className="logout-btn" onClick={logOut}>Logout</Button>
                    </div>
                </div>
            </aside>

            {/* 🔥 BULK IMPORT MODAL */}
            <ProductBulkImportModal
                open={bulkOpen}
                toggle={() => setBulkOpen(false)}
                onSuccess={() => setBulkOpen(false)}
            />

            <BulkStockUpload
                open={stockopen}
                toggle={() => setStockOpen(false)}
                onSuccess={() => setStockOpen(false)}
            />
        </>
    );
};

export default Sidebar;
